import React from 'react';
import AddFiledLienTemplateFields from '../AddFiledLienTemplateFields/AddFiledLienTemplateFields';

const FiledLienTemplatesFields = () => {
  return (
    <div className="w-full h-full">
      <AddFiledLienTemplateFields />
    </div>
  );
};

export default FiledLienTemplatesFields;
